import React, { useState } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap'; // Supposons l'utilisation de React-Bootstrap
import ApiService from "../../services/ApiService";

function ManualImports() {
    const [showModalAnimations, setShowModalAnimations] = useState(false);
    const [loadingAnimations, setLoadingAnimations] = useState(false);
    const [messageAnimations, setMessageAnimations] = useState('');
    const [showModalMarchandisings, setShowModalMarchandisings] = useState(false);
    const [loadingMarchandisings, setLoadingMarchandisings] = useState(false);
    const [messageMarchandisings, setMessageMarchandisings] = useState('');
  
    const handleStartProcessImportAnimations = async () => {
      setShowModalAnimations(true);
      setLoadingAnimations(true);
      setMessageAnimations("L'import des animations est en cours, vous recevrez un e-mail à l'adresse "+JSON.parse(localStorage.getItem("user"))[1]+" une fois qu'il sera terminé.");
  
      try {

        const response = await ApiService.request(
            {  },
            'manual-import-animations',
            'GET' 
        );
        //console.log('API Response:', response);
        setLoadingAnimations(false);
        setMessageAnimations(response.message || 'Tâche démarrée avec succès.');
  
      } catch (error) {
        console.error("Erreur API:", error);
        setLoadingAnimations(false);
        setMessageAnimations('Erreur: Impossible de démarrer le processus..');
      }
    };

    const handleStartProcessImportMarchandisings = async () => {
        setShowModalMarchandisings(true); // Ouvre la modale
        setLoadingMarchandisings(true);
        setMessageMarchandisings("L'import des merchandisings est en cours, vous recevrez un e-mail à l'adresse "+JSON.parse(localStorage.getItem("user"))[1]+" une fois qu'il sera terminé.");
    
        try {
  
          const response = await ApiService.request(
              {  },
              'manual-import-marchandisings',
              'GET' 
          );
          //console.log('API Response:', response);
          setLoadingMarchandisings(false);
          setMessageMarchandisings(response.message || 'Tâche démarrée avec succès.');
    
        } catch (error) {
          console.error("Erreur API:", error);
          setLoadingMarchandisings(false);
          setMessageMarchandisings('Erreur: Impossible de démarrer le processus..');
        }
      };
    
    return (
      <>
        <h1>Imports manuels de données</h1>

        <h2><strong>Animations</strong></h2>

        <Button variant="primary" onClick={handleStartProcessImportAnimations} disabled={loadingAnimations}>
            {loadingAnimations ? 'Démarrage...' : 'Importer les animations maintenant'}
        </Button>
        <Modal show={showModalAnimations} onHide={() => setShowModalAnimations(false)} backdrop="static" keyboard={false}>
          <Modal.Header closeButton>
            <Modal.Title>Import des animations en cours</Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center">
            {loadingAnimations && (
              <>
                <Spinner animation="border" role="status" className="mb-3" />
                <p>Démarrage de la tâche...</p>
              </>
            )}
            <p className={loadingAnimations ? 'text-muted' : 'text-success'}>
              {messageAnimations}
            </p>
            {!loadingAnimations && <p>Vous pouvez fermer cette fenêtre.</p>}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModalAnimations(false)} disabled={loadingAnimations}>
              Fermer
            </Button>
          </Modal.Footer>
        </Modal>

        <hr className="my-5" />

        <h2><strong>Merchandisings</strong></h2>

        <Button variant="primary" onClick={handleStartProcessImportMarchandisings} disabled={loadingMarchandisings}>
            {loadingMarchandisings ? 'Démarrage...' : 'Importer les merchandisings maintenant'}
        </Button>
        <Modal show={showModalMarchandisings} onHide={() => setShowModalMarchandisings(false)} backdrop="static" keyboard={false}>
          <Modal.Header closeButton>
            <Modal.Title>Import des merchandisings en cours</Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center">
            {loadingMarchandisings && (
              <>
                <Spinner animation="border" role="status" className="mb-3" />
                <p>Démarrage de la tâche...</p>
              </>
            )}
            <p className={loadingMarchandisings ? 'text-muted' : 'text-success'}>
              {messageMarchandisings}
            </p>
            {!loadingMarchandisings && <p>Vous pouvez fermer cette fenêtre.</p>}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModalMarchandisings(false)} disabled={loadingMarchandisings}>
              Fermer
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
  
  export default ManualImports;